import { Component, OnInit } from '@angular/core';
import { CompanyService } from 'src/app/shared/services/node-api/company.service';

@Component({
  selector: 'app-my-request-layout',
  templateUrl: './my-request-layout.component.html',
  styleUrls: ['./my-request-layout.component.scss']
})
export class MyRequestLayoutComponent implements OnInit {
  public myRequestList: any = [];

  constructor(
    private companyService: CompanyService,
  ) {}

  ngOnInit(): void {
    this.companyService
      .getUserNewCompanyRequestList()
      .then((data: any) => {
        this.myRequestList = data.data;
      })
      .catch((err) => {
        console.log(err);
      });
  }

}
